import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

export { default as Avatar } from './Avatar.vue';

const baseClasses = [
    'relative',
    'flex',
    'size-8',
    'shrink-0',
    'overflow-hidden',
    'bg-background-tertiary',
    'justify-center',
    'items-center',
    'text-center',
    'text-base',
    'border',
    'border-border-subdued-extra',
    "[&_svg:not([class*='size-'])]:size-6",
    'text-content-primary',
    'inverse:text-content-primary-inverse',
].join(' ');

export const avatarVariants = cva(baseClasses, {
    variants: {
        size: {
            lg: "size-12 [&_svg:not([class*='size-'])]:size-6",
            md: "size-10 [&_svg:not([class*='size-'])]:size-5",
            sm: "size-8 [&_svg:not([class*='size-'])]:size-4 text-sm",
        },
        square: {
            true: 'rounded-md',
            false: 'rounded-full',
        },
    },
    defaultVariants: {
        size: 'md',
        square: false,
    },
});

export type AvatarVariants = VariantProps<typeof avatarVariants>;
